<template>
    <div class="max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8 mb-4">
        <Head :title="modification.title" />
        <piped-title
            :first="$t('orderModifications.orderModification')"
            :second="modification.title"
            :pages="breadcrumbPages"
        ></piped-title>
    </div>
    <div class="max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8">
        <!-- ORDER MODIFICATION HEADER -->
        <div class="my-2">
            <div class="bg-minplan-beige text-minplan-blue">
                <div class="p-4 flex w-full">
                    <div>
                        <InformationCircleIcon
                            class="mr-2 h-5 w-5 text-minplan-darkgreybeige"
                        />
                    </div>
                    <div>
                        <span class="truncate inline-block w-full font-bold">{{
                                $t("orderModifications.description")
                            }}</span
                        ><br />
                        <p class="text-xs">{{ modification.description }}</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- / ORDER MODIFCATION HEADER -->

        <!-- INFO BAR -->
        <div class="my-2 pt-2 pb-3 flex justify-between items-center border-b">
            <div class="flex">
                <span
                    :class="modification.style"
                    class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full"
                >
                    {{ $t("orderModifications.states." + modification.state) }}
                </span>
            </div>

            <div class="flex">
                <button
                    @click="goToTopic"
                    class="inline-flex items-center text-gray-900 hover:text-gray-800 text-sm"
                >
                    <ArrowLeftIcon class="h-4 w-4 mr-2 text-gray-500" />
                    {{ $t("orderModifications.backTo") }} {{ topic.name }}
                </button>
            </div>
        </div>

        <!-- / INFO BAR -->

        <!-- OFFER LISTING -->
        <order-modification-offer-table
            :topic="topic"
            :offers="offers"
            :cost="modification.cost"
            :netCost="modification.netCost"
            :taxAmount="modification.taxAmount"
            :fees="modification.fees"
        />

        <!-- APPROVAL SECTION -->
        <div class="mt-3">
            <div class="mt-6 p-5 bg-white shadow rounded border border-gray-200">

                <state-actions
                    :patch-modification-route="patchModificationRoute"
                    :reject-modification-route="rejectModificationRoute"
                    :show-approve="showApprove"
                    :show-decline="showDecline"
                    :show-release="showRelease"
                    :offers="offers"
                ></state-actions>

                <!-- APPROVED MESSAGE DISPLAY -->
                <approved-message
                    :state="modification.state"
                    :approval-date="modification.approvalDate"
                    :last-approved-by="modification.lastApprovedBy"
                ></approved-message>

                <!-- DECLINED MESSAGE DISPLAY -->
                <declined-message
                    :state="modification.state"
                    :rejection-reason="modification.rejectionReason"
                ></declined-message>
            </div>
        </div>
    </div>
</template>
<script>
import { Head } from "@inertiajs/inertia-vue3";
import {
    ArrowLeftIcon,
    CheckCircleIcon,
    CheckIcon,
    CloudDownloadIcon,
    CloudUploadIcon,
    ExclamationCircleIcon,
    InformationCircleIcon,
    PaperAirplaneIcon,
    PencilIcon,
    PlusIcon,
    RefreshIcon,
    TrashIcon,
    XIcon
} from "@heroicons/vue/outline";
import { downloadFile } from "@/Shared/Utils/downloader";
import PipedTitle from "@/Shared/Components/PipedTitle";
import OrderModificationOfferTable from "@/Pages/OrderModifications/Components/OrderModificationOfferTable";
import ClientApartmentLayout from "@/Layouts/ClientApartmentLayout.vue";
import ApprovedMessage from "@/Shared/Components/OrderModifications/approved-message.vue";
import DeclinedMessage from "@/Shared/Components/OrderModifications/declined-message.vue";
import StateActions from "@/Shared/Components/OrderModifications/state-actions.vue";

export default {
    components: {
        Head,
        StateActions,
        DeclinedMessage,
        ApprovedMessage,
        XIcon,
        CheckIcon,
        PaperAirplaneIcon,
        RefreshIcon,
        InformationCircleIcon,
        PencilIcon,
        CloudDownloadIcon,
        TrashIcon,
        CloudUploadIcon,
        PipedTitle,
        PlusIcon,
        OrderModificationOfferTable,
        ExclamationCircleIcon,
        CheckCircleIcon,
        ArrowLeftIcon
    },
    props: [
        "apartment",
        "project",
        "topic",
        "modification",
        "offers",
        "createOfferRoute",
        "updateModificationRoute",
        "patchModificationRoute",
        "showRelease",
        "showApprove",
        "showDecline",
        "rejectModificationRoute"
    ],
    layout: ClientApartmentLayout,
    data() {
        return {};
    },
    methods: {
        download(offer) {
            downloadFile(offer.downloadLink, offer.filename);
        },
        goToTopic() {
            this.$inertia.visit(
                this.route("clients.apartments.topics.show", {
                    apartment: this.apartment.uuid,
                    topic: this.topic.uuid
                })
            );
        }
    },
    computed: {
        breadcrumbPages() {
            return [
                // {
                //     name: this.$t("projects.projects"),
                //     href: this.route("advisors.projects.index"),
                //     current: false,
                // },
                // {
                //     name: this.project.name,
                //     href: this.route("advisors.projects.show", {
                //         uuid: this.project.uuid,
                //     }),
                //     current: false,
                // },
                // {
                //     name: `${this.$t("apartments.apartment")} ${this.apartment.number}`,
                //     href: this.route("advisors.apartments.show", this.apartment.uuid),
                //     current: false,
                // },
                // {
                //     name: this.topic.name,
                //     href: this.route("advisors.apartments.topics.show", {
                //         apartment: this.apartment.uuid,
                //         topic: this.topic.uuid,
                //     }),
                //     current: false,
                // },
                // {
                //     name: this.modification.title,
                //     href: this.route("advisors.topics.order-modifications.show", {
                //         topic: this.topic.uuid,
                //         orderModification: this.modification.uuid,
                //     }),
                //     current: true,
                // },
            ];
        }
    },
    setup() {
    }
};
</script>
<style scoped></style>
